const JobsList = {
  props: {
    data: {
      default: {
        docs: [],
      },
    },
  },
  computed: {
    jobs() {
      return this.data.docs.sort(function (a, b) {
        if (a.status !== b.status) {
          if (a.status === 'closed') return 1;
          if (b.status === 'closed') return -1;
          if (a.status === 'inactive') return 1;
          if (b.status === 'inactive') return -1;
        }
        return a.createdAt > b.createdAt ? -1 : 1;
      });
    },
    pagination() {
      const pagination = { ...this.data };
      delete pagination.docs;
      return pagination;
    },
  },
  methods: {
    isRenewable(job) {
      const limit = 15 * 24 * 3600 * 1000;
      const gap = new Date(job.expiresAt).getTime() - new Date().getTime();
      return job.status === 'active' && gap < limit;
    },
    view(job) {
      this.$router.push({ name: 'job.view', params: { id: job._id } });
    },
    edit(job) {
      if (!['active', 'pending'].includes(job.status)) {
        return;
      }
      this.$router.push({ name: 'job.form', params: { id: job._id } });
    },
    reactivate(job) {
      return this.$dmtk.jobs
        .reactivate(job._id)
        .then((result) => {
          job.status = result.status;
        })
        .catch((e) => {
          customAlert(
            'Ha ocurrido un error',
            'Por favor vuelve a intentarlo dentro de unos minutos',
          );
        });
    },
    deactivate(job) {
      customConfirm(
        '¿Seguro que deseas desactivar la oferta?',
        'Si lo haces no recibirás más inscripciones, pero podrás seguir comunicándote con los candidatos ya inscritos.',
      )
        .then(() => {
          return this.$dmtk.jobs.deactivate(job._id);
        })
        .then((result) => {
          job.status = result.status;
        })
        .catch((e) => {
          customAlert(
            'Ha ocurrido un error',
            'Por favor vuelve a intentarlo dentro de unos minutos',
          );
        });
    },
    close(job) {
      customConfirm(
        '¿Seguro que deseas cerrar la oferta?',
        'Si lo haces no recibirás más inscripciones ni mensajes de tus candidatos. La oferta no podrá volver a abrirse.',
      )
        .then(() => {
          return this.$dmtk.jobs.close(job._id);
        })
        .then((result) => {
          job.status = result.status;
        })
        .catch((e) => {
          customAlert(
            'Ha ocurrido un error',
            'Por favor vuelve a intentarlo dentro de unos minutos',
          );
        });
    },
    renew(job) {
      return this.$dmtk.jobs
        .renew(job._id)
        .then((result) => {
          job.expiresAt = result.expiresAt;
          customAlert('¡Enhorabuena!', 'Tu anuncio ha sido renovado con éxito');
        })
        .catch((e) => {
          customAlert(
            'Ha ocurrido un error',
            'Por favor vuelve a intentarlo dentro de unos minutos',
          );
        });
    },
    remove(job) {
      customConfirm(
        '¿Seguro que deseas borrar la oferta?',
        'La oferta, sus inscripciones y todos sus mensajes desaparecerán definitivamente de Doméstiko.',
      )
        .then(() => {
          return this.$dmtk.jobs.delete(job._id);
        })
        .then((result) => {
          //Borramos del listado
          const idx = this.jobs.indexOf(job);
          if (idx >= 0) {
            this.jobs.splice(idx, 1);
          }
          //Cambiamos el número en el usuario
          this.$store.commit('removeUserJob');
        })
        .catch((e) => {
          customAlert(
            'Ha ocurrido un error',
            'Por favor vuelve a intentarlo dentro de unos minutos',
          );
        });
    },
  },
  template: `
    <div>
      <div class="job-list">
        <div class="job" v-for="job in jobs" :class="{ ['-'+job.status]: true }">
          <div class="uk-grid">
            <div class="uk-width-expand info" @click="view(job)">
              <strong>{{ job.title }}</strong><br>
              {{ job.activity.name }} en {{ job.location.title }}<br>
              <small>
                <span v-if="job.status === 'pending'">
              		Pendiente de activación
                </span>
                <span v-if="job.status === 'active'">
              		Oferta activa
                </span>
                <span v-if="job.status === 'inactive'">
              		Oferta inactiva
                </span>
                <span v-if="job.status === 'closed'">
              		Oferta cerrada
                </span>
                | Añadida el {{ job.createdAt | dateFormat('D [de] MMMM') }} |
                Caduca el {{ job.expiresAt | dateFormat('D [de] MMMM') }}
              </small>
            </div>
            <div>
              <button class="uk-button uk-button-ellipsis"></button>
              <div uk-dropdown="mode: click">
                <ul class="uk-nav uk-dropdown-nav">
                  <li v-if="job.status === 'active'">
                    <a @click="view(job)">Ver oferta</a>
                  </li>
                  <li v-if="job.status === 'active'">
                    <a :href="'/empleo/oferta/'+job.slug+'/'" target="_blank">Mostrar oferta pública</a>
                  </li>
                  <li v-if="['active', 'inactive'].indexOf(job.status) >= 0">
                    <router-link to="/mensajes">Ver inscripciones</router-link>
                  </li>
                  <li v-if="['active', 'pending'].indexOf(job.status) >= 0">
                    <a @click="edit(job)">Editar oferta</a>
                  </li>
                  <li v-if="isRenewable(job)">
                    <a @click="renew(job)">Renovar oferta</a>
                  </li>
                  <li v-if="job.status === 'active'">
                    <a @click="deactivate(job)">Desactivar oferta</a>
                  </li>
                  <li v-if="job.status === 'inactive'">
                    <a @click="reactivate(job)">Reactivar oferta</a>
                  </li>
                  <li v-if="['active', 'inactive'].indexOf(job.status) >= 0">
                    <a @click="close(job)">Cerrar oferta</a>
                  </li>
                  <li class="uk-nav-divider"></li>
                  <li>
                    <a @click="remove(job)" class="uk-text-danger">Borrar oferta</a>
                  </li>
                  <li class="uk-nav-divider"></li>
                  <li>
                    <a href="/ayuda/" target="_blank">Ayuda</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
};
